export default "__VITE_ASSET__aa4b0eed__"